export default {
    classInfo: {
        teacherName: '{name} 선생님',
        button: {
            delete: '삭제',
            update: '변경',
            upload: '이미지 변경',
        },
    },
    mainMenu: {
        title: '메인 메뉴',
        dashboard: '대시보드',
        students: '학생 관리',
        session: '수업 구성',
        history: '수업 기록',
    },
    usageGuide: {
        title: '사용 안내',
        usageGuide: '매일국어T 사용 가이드',
        activityGuide: '매일국어T 활동 설명',
        updateGuide: '업데이트 내역',
        csGuide: '1:1 문의',
    },
    etc: {
        title: '기타',
        myPage: '내 정보',
        logout: '로그아웃',
        logoutConfirm: '로그아웃 할까요?',
    },
};
